import {
  agedcheddar,
  almondbutter,
  artisanbread,
  blueberryjam,
  darkchocolate,
  greentea,
  handcraftedsausages,
  oliveoil,
  organic_eggs,
  organicapples,
  organichoney,
  premiumcoffee,
  quinoa,
  spaghettipasta,
  wholegrainmustard,
} from "../assets";

export const products = [
  {
    id: 1,
    name: "Artisan Bread",
    description: "Handmade with organic flour, perfect for sandwiches.",
    imageUrl: artisanbread,
    price: 4.99,
  },
  {
    id: 2,
    name: "Organic Honey",
    description: "Pure, natural honey, ideal for sweetening and cooking.",
    imageUrl: organichoney,
    price: 12.5,
  },
  {
    id: 3,
    name: "Premium Coffee",
    description: "Rich and smooth blend of the finest Arabica beans.",
    imageUrl: premiumcoffee,
    price: 15.99,
  },
  {
    id: 4,
    name: "Green Tea",
    description: "Refreshing and soothing, sourced from organic farms.",
    imageUrl: greentea,
    price: 9.99,
  },
  {
    id: 5,
    name: "Dark Chocolate",
    description: "70% cocoa, enriched with antioxidants.",
    imageUrl: darkchocolate,
    price: 3.99,
  },
  {
    id: 6,
    name: "Extra Virgin Olive Oil",
    description: "Cold-pressed, perfect for dressing and cooking.",
    imageUrl: oliveoil,
    price: 10.99,
  },
  {
    id: 7,
    name: "Almond Butter",
    description: "Smooth and creamy, made from 100% pure almonds.",
    imageUrl: almondbutter,
    price: 7.99,
  },
  {
    id: 8,
    name: "Spaghetti Pasta",
    description: "Durum wheat pasta that cooks to al dente perfection.",
    imageUrl: spaghettipasta,
    price: 2.99,
  },
  {
    id: 9,
    name: "Organic Eggs",
    description: "Free-range eggs, rich in flavor and nutrition.",
    imageUrl: organic_eggs,
    price: 4.5,
  },
  {
    id: 10,
    name: "Blueberry Jam",
    description: "Made with ripe blueberries, perfect for breakfast.",
    imageUrl: blueberryjam,
    price: 5.99,
  },
  {
    id: 11,
    name: "Quinoa",
    description: "High-protein, gluten-free superfood.",
    imageUrl: quinoa,
    price: 6.99,
  },
  {
    id: 12,
    name: "Aged Cheddar Cheese",
    description: "Rich flavor, aged for two years.",
    imageUrl: agedcheddar,
    price: 8.99,
  },
  {
    id: 13,
    name: "Whole Grain Mustard",
    description: "Robust flavor, great for sandwiches and dressings.",
    imageUrl: wholegrainmustard,
    price: 3.49,
  },
  {
    id: 14,
    name: "Organic Apples",
    description: "Crisp and juicy, freshly picked from organic orchards.",
    imageUrl: organicapples,
    price: 2.99,
  },
  {
    id: 15,
    name: "Handcrafted Sausages",
    description: "Seasoned with natural spices, free from additives.",
    imageUrl: handcraftedsausages,
    price: 14.99,
  },
];
